/* eslint-disable */
import React, { useState } from 'react';
import { Ico } from './ShellIcons';
import fb from './filterBar.module.css';
import pop from './popovers.module.css';

// ============================================================
// The right-cluster controls of the filter bar, one shape each:
//   MenuControl   — "SORT · Newest" / "GROUP · None" with a check-list menu
//   ViewsMenu     — saved views (bookmark): apply · save current · delete
//   DensityToggle — cards | compact
//   ActionButton / PrimaryButton — outlined text button · amber pill
// Menus open through the shell's single `open` key (one popover at a time).
// ============================================================

const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));

export function MenuControl({ id, icon, small, value, items, onPick, open, onToggle, kind, title, descending, onToggleDir }) {
  const cur = items.find((i) => i.key === value) || items[0];
  return (
    <div className={fb.ffw}>
      <button type="button" className={`${fb.ctl} ${kind ? fb[kind] : ''} ${open ? fb.open : ''}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-haspopup="menu" aria-expanded={open} title={title || small}>
        <span className={fb.ci}><Ico name={icon} /></span>
        <span className={fb.cl}><small>{small}</small><b>{cur ? cur.label : '—'}</b></span>
        <Ico name="chev" className={fb.chev} />
      </button>
      {open && (
        <div className={pop.menu} role="menu" data-shell-pop onClick={(e) => e.stopPropagation()}>
          <div className={pop.fsec}>{small} by</div>
          {items.map((it) => (
            <button key={it.key} type="button" role="menuitemradio" aria-checked={it.key === value} className={`${pop.mi} ${it.key === value ? pop.on : ''}`} onClick={() => onPick(it.key)}>
              {it.key === value ? <Ico name="check" /> : <span className={pop.sp} />}{it.label}{it.count != null && <span className={pop.k}>{fmt(it.count)}</span>}
            </button>
          ))}
          {onToggleDir && <><div className={pop.mdiv} /><button type="button" className={pop.mi} onClick={onToggleDir}><Ico name={descending ? 'download' : 'upload'} />{descending ? 'Descending' : 'Ascending'}</button></>}
        </div>
      )}
    </div>
  );
}

export function ViewsMenu({ views, onApply, onSave, onDelete, open, onToggle, label, count, iconOnly }) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  return (
    <div className={fb.ffw}>
      <button type="button" className={`${fb.ctl} ${fb.viewsBtn} ${iconOnly ? fb.ic : ''} ${open ? fb.open : ''}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-haspopup="menu" aria-expanded={open} title="Saved views">
        <Ico name="bookmark" />
        {!iconOnly && <span className={fb.cl}><b>{label || 'Views'}</b>{count ? <span className={fb.vc}>{count}</span> : null}</span>}
        {!iconOnly && <Ico name="chev" className={fb.chev} />}
      </button>
      {open && (
        <div className={pop.menu} role="menu" data-shell-pop onClick={(e) => e.stopPropagation()}>
          <div className={pop.fsec}>My views</div>
          {views.length === 0 && <div className={pop.fempty}>No saved views yet — set filters, then save.</div>}
          {views.map((v) => (
            <button key={v.id} type="button" role="menuitem" className={pop.mi} onClick={() => onApply(v)}>
              <Ico name="bookmark" /><span>{v.name}</span>
              {v.count != null && <span className={pop.k}>{fmt(v.count)}</span>}
              <span className={pop.del} role="button" aria-label={`Delete view ${v.name}`} onClick={(e) => { e.stopPropagation(); onDelete(v); }}><Ico name="x" /></span>
            </button>
          ))}
          <div className={pop.mdiv} />
          {!saving ? (
            <button type="button" className={pop.mi} onClick={() => setSaving(true)}><Ico name="plus" />Save current view…</button>
          ) : (
            <form className={pop.miForm} onSubmit={(e) => { e.preventDefault(); if (name.trim()) { onSave(name.trim()); setName(''); setSaving(false); } }}>
              <input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder="Name this view" aria-label="View name" maxLength={40} onKeyDown={(e) => { if (e.key === 'Escape') { setSaving(false); e.stopPropagation(); } }} />
              <button type="submit" disabled={!name.trim()}>Save</button>
            </form>
          )}
        </div>
      )}
    </div>
  );
}

export function DensityToggle({ value, onChange }) {
  return (
    <div className={fb.dens} title="Density" role="group" aria-label="Density">
      <button type="button" className={value !== 'compact' ? fb.on : ''} aria-pressed={value !== 'compact'} onClick={() => onChange('cards')} title="Cards"><Ico name="gridIc" /></button>
      <button type="button" className={value === 'compact' ? fb.on : ''} aria-pressed={value === 'compact'} onClick={() => onChange('compact')} title="Compact"><Ico name="denseIc" /></button>
    </div>
  );
}

export function ActionButton({ icon, label, onClick, title, disabled }) {
  return <button type="button" className={`${fb.btn} ${fb.txt}`} onClick={onClick} title={title || label} disabled={disabled}><Ico name={icon} /><span>{label}</span></button>;
}

export function PrimaryButton({ label, onClick, icon = 'plus', title, disabled }) {
  return <button type="button" className={`${fb.btn} ${fb.primary}`} onClick={onClick} title={title || label} disabled={disabled}><Ico name={icon} /><span>{label}</span></button>;
}

export function AuxButton({ icon, title, onClick, on, hideOnTouch }) {
  return <button type="button" className={`${fb.ctl} ${fb.ic} ${fb.aux} ${on ? fb.on : ''}`} title={title} aria-label={title} aria-pressed={on} onClick={onClick} data-hide-on-touch={hideOnTouch ? '' : undefined}><Ico name={icon} /></button>;
}
